<div class="container">
    <div class="row">
        <div class="col-12">
            <p>Proceso finalizado</p>
        </div>
    </div>
</div>
